import constants from "./constants";
import getApiHeaders from './apiHeaders.js';

const buildGraph = async (body) => {
    const response = await fetch(
        constants.buildGraphUrl, {
        method: 'POST',
        headers: getApiHeaders(),
        body: JSON.stringify(body),
        credentials: "include"
    });

    if (!response.ok) {
        throw response;
    }

    if (response.status === 204) {
        body.status = response.status
        return body
    }

    return await response.json();
}

export default buildGraph;